import Lenis from "lenis";

export default function lenisInit() {
  const lenis = new Lenis();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  /* lenis.on("scroll", (e) => {
    console.log(e);
  }); */
}
